import { context } from "../../components/wr-context";
function salesforceConnectionMonkeyPatch(conn) {
    var ref;
    var ref1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref = {}, ref), token = ref1.token, authorization = ref1.authorization, chainedAdapter = ref1.chainedAdapter;
    var _request = conn.request.bind(conn);
    conn.request = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var ref;
        if (!args[0].headers) {
            args[0].headers = {};
        }
        var headers = args[0].headers;
        headers.Authorization = authorization || ((ref = context.state) === null || ref === void 0 ? void 0 : ref.authorization);
        headers.token = token || process.env.REACT_APP_WR_ACCESS_TOKEN;
        if (chainedAdapter) {
            headers["x-wr-act-chain"] = chainedAdapter;
        }
        return _request.apply(conn, args);
    };
}
export default salesforceConnectionMonkeyPatch;
